// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3KqS4","header":"ReportDetails_header__3ycnD","title":"ReportDetails_title__iVV4e","left":"ReportDetails_left__1rnqI"};